import { render, staticRenderFns } from "./PropertySheet.vue?vue&type=template&id=35d9fe2f&scoped=true"
import script from "./PropertySheet.vue?vue&type=script&lang=js"
export * from "./PropertySheet.vue?vue&type=script&lang=js"
import style0 from "./PropertySheet.vue?vue&type=style&index=0&id=35d9fe2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9fe2f",
  null
  
)

export default component.exports